module.exports = __webpack_public_path__ + "static/img/real_banner.5d2286c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/real_banner.png
// module id = zpmn
// module chunks = 1